import { render, staticRenderFns } from "./ProofOfAddress.vue?vue&type=template&id=f1a1cef8&scoped=true"
import script from "./ProofOfAddress.vue?vue&type=script&lang=js"
export * from "./ProofOfAddress.vue?vue&type=script&lang=js"
import style0 from "./ProofOfAddress.vue?vue&type=style&index=0&id=f1a1cef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a1cef8",
  null
  
)

export default component.exports